import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'

// GET platform reviews
export const get_platform_reviews = createAsyncThunk(
    'platformReview/get',
    async ({ page = 1, limit = 12 } = {}, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.get(`/home/customer/platform-reviews?page=${page}&limit=${limit}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)

// GET my platform review (already-submitted state) — logged-in only
export const get_my_platform_review = createAsyncThunk(
    'platformReview/getMine',
    async (_, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.get('/home/customer/platform-reviews/mine')
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)

// POST platform review
export const submit_platform_review = createAsyncThunk(
    'platformReview/submit',
    async (reviewData, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.post('/home/customer/platform-reviews', reviewData)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)
export const delete_platform_review = createAsyncThunk(
    'platformReview/delete',
    async (id, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.delete(`/home/customer/platform-reviews/${id}`)
            return fulfillWithValue({ id, message: data.message })
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)

const platformReviewSlice = createSlice({
    name: 'platformReview',
    initialState: {
        reviews:         [],
        total:           0,
        page:            1,
        totalPages:      1,
        avgRating:       0,
        ratingBreakdown: [],
        myReview:        null,
        myReviewChecked: false,
        loader:          false,
        submitLoader:    false,
        successMessage:  '',
        errorMessage:    ''
    },
    reducers: {
        messageClear: (state) => {
            state.successMessage = ''
            state.errorMessage   = ''
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(get_platform_reviews.pending, (state) => {
                state.loader = true
            })
            .addCase(get_platform_reviews.fulfilled, (state, { payload }) => {
                state.loader         = false
                state.reviews        = payload.reviews
                state.total          = payload.total
                state.page           = payload.page
                state.totalPages     = payload.totalPages
                state.avgRating      = payload.avgRating
                state.ratingBreakdown = payload.ratingBreakdown
            })
            .addCase(get_platform_reviews.rejected, (state) => {
                state.loader = false
            })
            .addCase(get_my_platform_review.fulfilled, (state, { payload }) => {
                state.myReview = payload.review || null
                state.myReviewChecked = true
            })
            .addCase(get_my_platform_review.rejected, (state) => {
                state.myReviewChecked = true
            })
            .addCase(submit_platform_review.pending, (state) => {
                state.submitLoader = true
            })
            .addCase(submit_platform_review.fulfilled, (state, { payload }) => {
                state.submitLoader  = false
                state.successMessage = payload.message
                // Göndərildikdən sonra "artıq göndərilib" vəziyyətinə keç
                state.myReview = state.myReview || { status: 'pending' }
            })
            .addCase(submit_platform_review.rejected, (state, { payload }) => {
                state.submitLoader = false
                state.errorMessage = payload?.message || 'Xəta baş verdi'
            })
               .addCase(delete_platform_review.pending, (state, action) => {
                // Could use this to toggle a loading UI for specific id if desired
            })
            .addCase(delete_platform_review.fulfilled, (state, { payload }) => {
                // Remove deleted review from current list and update totals
                state.reviews = state.reviews.filter(r => String(r._id) !== String(payload.id))
                state.total = Math.max(0, state.total - 1)
                state.totalPages = Math.max(1, Math.ceil(state.total / 12))
            })
            .addCase(delete_platform_review.rejected, (state, { payload }) => {
                state.errorMessage = payload?.message || 'Rəy silinərkən xəta baş verdi'
            })
    }
})

export const { messageClear } = platformReviewSlice.actions
export default platformReviewSlice.reducer